<div fxLayout="column">
    <div fxFlex="47.5" fxFlex.lt-md="100" *ngIf="this.type==='inquiry'">
        <mat-card class="product-overview-card" fxLayout="column"  fxLayoutAlign="space-between center" >
            <p>{{'inquiryBrokenText' | translate}}</p>
        </mat-card>
    </div>
    <h4>{{'pdTitle' | translate}}</h4>
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutAlign.lt-md="space-around center" fxLayoutGap.gt-md="12px">
        <mat-card *ngFor="let category of this.categories" class="category-card" (click)="selectProblem(category.enName)" [ngClass]="{'selected-problem': this.checkIfProblemIsSelected(category.enName)}"  fxFlex="19" fxFlex.lt-md="40" fxLayout="column" fxLayoutAlign="space-around center">
            <button mat-fab color="primary" aria-label="Bluetooth>">
                <mat-icon>{{category.imageName}}</mat-icon>
              </button>
              <p *ngIf="this.selectedLanguage === 'en'">{{category.enName}}</p>
              <p *ngIf="this.selectedLanguage === 'fr'">{{category.frName}}</p>
              <p *ngIf="this.selectedLanguage === 'nl'">{{category.nlName}}</p>
        </mat-card>
        
    </div>

    <form class="description-container" fxLayout="row" #descriptionForm="ngForm" fxLayoutAlign="space-around center">
        <mat-form-field fxFill appearance="fill">
            <mat-label>{{'pdDescription' | translate}}</mat-label>
            <textarea required [(ngModel)]="request.description" name="description" matInput rows="8"></textarea>
          </mat-form-field>
    </form>

    <div>
        <h4>{{'pdAtTitle' | translate}}</h4>
        <div>
           <p>{{'pdAttext1' | translate}}</p>

           <ul>
            <li>{{'pdAtli1' | translate}}</li>
            <li>{{'pdAtli2' | translate}}</li>
            <li>{{'pdAtli3' | translate}}</li>
            <li>{{'pdAtli4' | translate}}</li>
           </ul>

           <p>{{'pdAttext4' | translate}}</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="30" fxLayout="column" fxLayoutAlign="start start">
                <p>{{'pdAtfront1' | translate}}<br/>
                {{'pdAtex' | translate}}</p>
                <img src="../../../assets/images/IpadFront.jpg" width="50%" height="auto"/>
            </div>

            <div fxFlex="30" fxLayout="column" fxLayoutAlign="start start">
                <p>{{'pdAtback' | translate}}<br/>
                    {{'pdAtex' | translate}}</p>
                <img src="../../../assets/images/IpadBack.jpg" width="50%" height="auto"/>
            </div>

            <div fxFlex="30" fxLayout="column" fxLayoutAlign="start start">
                <p>{{'pdAtser1' | translate}}<br/>
                {{'pdAtser2' | translate}}</p>
                <img src="../../../assets/images/IpadSerial.jpg" width="50%" height="auto"/>
            </div>
        </div>
    </div>

    <div class="add-attachments">
        <div fxLayout="column" fxLayoutAlign="space-around start">
            <div *ngFor="let attachment of this.request.attachments; let i = index">
                {{attachment.path}}
                <button mat-icon-button color="warn" (click)="removeAttachment(i)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        <button [disabled]="this.disableUploadButton" mat-raised-button (click)="fileInput.click()" fxLayoutGap="10px">
            {{'pdAtbutton' | translate}}
            <input #fileInput type="file" multiple="multiple" (change)="onFileInput($any($event).target.files)" accept="image/x-png,image/jpeg,image/gif" style="display: none;"/>
        </button>
        
    </div>

    <div class="p-1" fxLayout="row" fxLayoutAlign="space-evenly center">
        <button mat-raised-button color="primary" (click)="back()"><mat-icon>arrow_back</mat-icon></button>
        <button mat-raised-button color="primary" [routerLink]="['/home']"><mat-icon >home</mat-icon></button>
        <button mat-raised-button color="primary" [disabled]="!request.description || selectedProblems.length == 0" (click)="onSubmit()"><mat-icon>arrow_forward</mat-icon></button>
    </div>
    
</div>

